import React, { useEffect, useState } from "react";
import SendEmail from "../SendEmail/SendEmail";
import ApproverRegister from "./ApproverRegister";
import ClerkRegister from "./ClerkRegister";

const ClientRegister = (props) => {
  const [sendmailallowed, setsendmailallowed] = useState(false);

  useEffect(() => {
    setsendmailallowed(false);
    nextapicall();
  }, []);

  const nextapicall = async () => {
    console.log("clientfile")
    let response = await fetch(
      `http://localhost:8080/auth/admin/realms/forms-flow-ai/users`,
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        Origin: "http://localhost:8080",
        headers: {
          "Content-Type": "application/json",
          Host: "localhost:8080",
          "Content-Length": JSON.stringify({
            enabled: true,
            attributes: {},
            groups: ["/formsflow/formsflow-client"],
            username: props.submissiondata.data.clientname,
            emailVerified: "",
            credentials: [
              {
                type: "password",
                value: "changeme",
                temporary: "true",
              },
            ],
            email: props.submissiondata.data.clientemail,
          }).length,

          Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify({
          enabled: true,
          attributes: {},
          groups: ["/formsflow/formsflow-client"],
          username: props.submissiondata.data.clientname,
          emailVerified: "",
          credentials: [
            {
              type: "password",
              value: "changeme",
              temporary: "true",
            },
          ],
          email: props.submissiondata.data.clientemail,
        }), // body data type must match "Content-Type" header
      }
    )
      .then((result) => {
        setsendmailallowed(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {sendmailallowed && (
        <SendEmail
          clientEmailId={props.submissiondata.data.clientemail}
          clientName={props.submissiondata.data.clientname}
        />
      )}
      {sendmailallowed && (
        <ClerkRegister submissiondata={props.submissiondata} />
      )}
    </>
  );
};

export default ClientRegister;
